import { configureStore } from '@reduxjs/toolkit';
import drawerSlice from './drawer/drawer.slice';
import modalSlice from './modal/modal.slice';
import themeSwitcherSlice from './theme-switcher/theme-switcher.slice';
import languageSwitcherSlice from './language-switcher/language-switcher.slice';
import authSlice from './auth/auth.slice';
import appSlice from './app/app.slice';
import notificationFetchSlice from './notification-fetch/notification-fetch.slice';
import notificationClickSlice from './notification-click/notification-click.slice';
import notificationSetOperatorSlice from './notification-set-operator/notification-set-operator.slice';
import sonyToolPropSlice from './sony-tool-prop-slice/sony-tool-prop-slice';

export default configureStore({
  reducer: {
    app: appSlice,
    auth: authSlice,
    drawer: drawerSlice,
    modal: modalSlice,
    themeSwitcher: themeSwitcherSlice,
    languageSwitcher: languageSwitcherSlice,
    notificationFetch: notificationFetchSlice,
    notificationClick: notificationClickSlice,
    notificationSetOperator: notificationSetOperatorSlice,
    sonyToolProp: sonyToolPropSlice,
  },
});
